import { render, staticRenderFns } from "./MemberInfoPopup.vue?vue&type=template&id=53d8c3f1&"
import script from "./MemberInfoPopup.vue?vue&type=script&lang=js&"
export * from "./MemberInfoPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports